/*eslint-disable*/
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
// core components
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.js";

import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";

const useStyles = makeStyles(styles);

export default function Sidebar(props) {
  const [userRole, setUserRole] = useState();

  const classes = useStyles();
  // verifies if routeName is the one active (in browser input)
  function activeRoute(routeName) {
    return window.location.href.indexOf(routeName) > -1 ? true : false;
  }
  const { color, image, routes } = props;

  const [normalRoutes, setNormalRoutes] = useState();
  const [soRoutes, setSoRoutes] = useState();
  const [soRouteReady, setSoRouteReady] = useState(0);

  useEffect(() => {
    const dataNew = localStorage?.getItem("user");
    setUserRole(JSON.parse(dataNew)?.role?.id);

    setNormalRoutes(routes);
    setSoRoutes(routes);
  }, []);

  useEffect(() => {
    if (soRoutes && userRole === 3) {
      const REMOVE_INDEX = ["1", "2", "4", "6", "7", "8", "9", "10", "11"];
      for (var i = REMOVE_INDEX.length - 1; i >= 0; i--) {
        soRoutes.splice(REMOVE_INDEX[i], 1);
      }
      setSoRouteReady(1);
    }
  }, [soRoutes, userRole]);

  var links = (
    <>
      {userRole === 3 && (
        <List className={classes.list}>
          {soRoutes &&
            soRouteReady &&
            soRoutes.map((prop, key) => {
              var activePro = " ";
              var listItemClasses;
              if (prop.path === "/upgrade-to-pro") {
                activePro = classes.activePro + " ";
                listItemClasses = classNames({
                  [" " + classes[color]]: true,
                });
              } else {
                listItemClasses = classNames({
                  [" " + classes[color]]: activeRoute(prop.layout + prop.path),
                });
              }
              const whiteFontClasses = classNames({
                [" " + classes.whiteFont]: activeRoute(prop.layout + prop.path),
              });
              return (
                <NavLink
                  to={prop.layout + prop.path}
                  className={activePro + classes.item}
                  activeClassName="active"
                  key={key}
                >
                  <ListItem
                    button
                    className={classes.itemLink + listItemClasses}
                  >
                    {typeof prop.icon === "string" ? (
                      <Icon
                        className={classNames(
                          classes.itemIcon,
                          whiteFontClasses
                        )}
                      >
                        {prop.icon}
                      </Icon>
                    ) : (
                      <prop.icon
                        className={classNames(
                          classes.itemIcon,
                          whiteFontClasses
                        )}
                      />
                    )}
                    <ListItemText
                      primary={prop.name}
                      className={classNames(classes.itemText, whiteFontClasses)}
                      disableTypography={true}
                    />
                  </ListItem>
                </NavLink>
              );
            })}
        </List>
      )}
      {userRole !== 3 && (
        <List className={classes.list}>
          {normalRoutes &&
            normalRoutes.map((prop, key) => {
              var activePro = " ";
              var listItemClasses;
              if (prop.path === "/upgrade-to-pro") {
                activePro = classes.activePro + " ";
                listItemClasses = classNames({
                  [" " + classes[color]]: true,
                });
              } else {
                listItemClasses = classNames({
                  [" " + classes[color]]: activeRoute(prop.layout + prop.path),
                });
              }
              const whiteFontClasses = classNames({
                [" " + classes.whiteFont]: activeRoute(prop.layout + prop.path),
              });
              return (
                <NavLink
                  to={prop.layout + prop.path}
                  className={activePro + classes.item}
                  activeClassName="active"
                  key={key}
                >
                  <ListItem
                    button
                    className={classes.itemLink + listItemClasses}
                  >
                    {typeof prop.icon === "string" ? (
                      <Icon
                        className={classNames(
                          classes.itemIcon,
                          whiteFontClasses
                        )}
                      >
                        {prop.icon}
                      </Icon>
                    ) : (
                      <prop.icon
                        className={classNames(
                          classes.itemIcon,
                          whiteFontClasses
                        )}
                      />
                    )}
                    <ListItemText
                      primary={prop.name}
                      className={classNames(classes.itemText, whiteFontClasses)}
                      disableTypography={true}
                    />
                  </ListItem>
                </NavLink>
              );
            })}
        </List>
      )}
    </>
  );

  var brand = (
    <div className={classes.logo}>
      <a href="#" className={classNames(classes.logoLink)} target="_self">
        <div style={{}}>
          {/* <img src={logo} alt="logo" style={{ width: "100%" }} /> */}
        </div>
      </a>
    </div>
  );

  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={"right"}
          open={props.open}
          classes={{
            paper: classNames(classes.drawerPaper),
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>
            <AdminNavbarLinks />
            {links}
          </div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          anchor={"left"}
          variant="permanent"
          open
          classes={{
            paper: classNames(classes.drawerPaper),
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>{links}</div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
    </div>
  );
}

Sidebar.propTypes = {
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool,
};
